module.exports = __webpack_public_path__ + "static/media/imac-scrn-aa-user-journey-v3.aa8bdf11.jpg";